import React from "react";
import { CrewPilotModuleShell } from "../CrewPilotModuleShell";
import { PAGE_LAYOUT } from "../../layout/pageLayout";
import { AdminInvitationsPanel } from "./panels/AdminInvitationsPanel";

export function AdminInvitationsScreen({ onBack }) {
  return (
    <CrewPilotModuleShell
      title="Organization Invitations"
      subtitle="Invite members and manage pending invitations"
      sectionLabel="People"
      onBack={onBack}
      layout={PAGE_LAYOUT.COMMAND}
    >
      <AdminInvitationsPanel />
    </CrewPilotModuleShell>
  );
}
